import { render, staticRenderFns } from "./matching-question-component.vue?vue&type=template&id=780dd898&scoped=true&"
import script from "./matching-question-component.vue?vue&type=script&lang=ts&"
export * from "./matching-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./matching-question-component.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./matching-question-component.vue?vue&type=style&index=1&id=780dd898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780dd898",
  null
  
)

export default component.exports